module.exports = __webpack_public_path__ + "img/food_icecream.29548572.png";